export const PAYMENT_WIDGET_ID_ACQ = 'payment-tools-overlay';

export const PAYMENT_WIDGET_POPUP_KEY = 'paymentWidget';

export const getPaymentWidgetNode = (): HTMLElement | null =>
    typeof window === 'undefined' ? null : document.getElementById(PAYMENT_WIDGET_ID_ACQ);
